import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=3188ce52&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=3188ce52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188ce52",
  null
  
)

export default component.exports